var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('vue-headful',{attrs:{"title":"TZ Design Box - Login","description":"TZ Design Box"}}),_c('section',{staticClass:"section login"},[_c('LoginBox')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }